import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel, IconLabelHintDirection } from '../../../IconLabel';

import classes from './History.module.scss';

interface HistoryProps {
  editor: Editor;
}

export const History: FunctionComponent<HistoryProps> = ({ editor }) => {
  const { t } = useTranslation();

  const { canUndo, canRedo } = useEditorState({
    editor,
    selector: ({ editor }) => ({ canUndo: editor.can().undo(), canRedo: editor.can().redo() }),
  });

  return (
    <div className={classes['history']}>
      <IconLabel
        iconId={'undo'}
        iconSize={20}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => editor.chain().undo().run()}
        disabled={!canUndo}
        data={t('common.undo')}
        hintDirection={IconLabelHintDirection.top}
      />
      <IconLabel
        iconId={'redo'}
        iconSize={20}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => editor.chain().redo().run()}
        disabled={!canRedo}
        data={t('common.redo')}
        hintDirection={IconLabelHintDirection.top}
      />
    </div>
  );
};
